import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import { FaSun, FaMoon, FaMusic, FaHeadphones } from 'react-icons/fa';
import '../styles/Navbar.css';

const Navbar = () => {
  const { darkMode, toggleDarkMode } = useTheme();

  return (
    <nav className="navbar">
      <div className="container navbar-container">
        <Link to="/" className="navbar-logo">
          <FaMusic className="logo-icon" />
          <span>Harmoniq</span>
        </Link>
        
        <div className="navbar-links">
          <NavLink to="/" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'} end>
            Accueil
          </NavLink>
          <NavLink to="/library" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
            Bibliothèque
          </NavLink>
          <NavLink to="/playlists" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
            Playlists
          </NavLink>
          <NavLink to="/upload" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
            Importer
          </NavLink>
          <NavLink to="/youtube" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
            YouTube
          </NavLink>
          <NavLink to="/djmixer" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
            <FaHeadphones className="nav-icon" /> DJ Mixer
          </NavLink>
        </div>
        
        <button className="theme-toggle" onClick={toggleDarkMode} aria-label="Toggle dark mode">
          {darkMode ? <FaSun /> : <FaMoon />}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
